import styled from "styled-components";

export const NudgeBotMessageAvatar =
  styled.img((props) => props?.theme?.themeConfig?.nudge?.botMessage?.avatar?.styles);